module.exports = __webpack_public_path__ + "static/img/wiseBrain02.d8bf195.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wiseBrain02.png
// module id = e8qB
// module chunks = 1